import { useEffect, useMemo, type ReactElement, type ReactNode } from 'react';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { useLingui } from '@lingui/react';
import { applyDocumentLocale, getDocumentDirection } from '../utils/locale';
import { AppearanceProvider, useAppAppearance } from '../contexts/AppearanceContext';

interface AppLocaleProviderProps {
  children: ReactNode;
}

export default function AppLocaleProvider({ children }: AppLocaleProviderProps): ReactElement {
  return <AppearanceProvider><LocalizedTheme>{children}</LocalizedTheme></AppearanceProvider>;
}

function LocalizedTheme({ children }: AppLocaleProviderProps): ReactElement {
  const { i18n } = useLingui();
  const { mode } = useAppAppearance();
  const direction: 'rtl' | 'ltr' = getDocumentDirection(i18n.locale);
  const theme = useMemo(() => createTheme({
    direction,
    palette: { mode, primary: { main: '#1976d2' } },
  }), [direction, mode]);

  useEffect(() => {
    applyDocumentLocale(i18n.locale);
  }, [i18n.locale]);

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
}
